import { render, staticRenderFns } from "./StateProvider.vue?vue&type=template&id=b5886e7a&"
import script from "./StateProvider.vue?vue&type=script&lang=js&"
export * from "./StateProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports